const advertise = {
    dfdh: '대상 전화:',
    sjmc: '상가명',
    qsrsj: '상가명을 입력하세요',
    sjbzj: '상가 보증금',
    wcl: '30일 완성률',
    zcd: '총 거래(매수/매도)',
    cd: '30일 거래',
    c: '번',
    fz: '분',
    pjfx: '평균 허용',
    zcsj: '등록 시간：',
    fbjy: '첫 번째 방문을 위한 법화 거래:',
    yxbd: '이메일 바인딩',
    sjbd: '핸드폰 바인딩',
    cjsm: '초급 실명 인증',
    gjsm: '고급 실명 인증',
    buy: '구매',
    sell: '판매',
    market: '시장',
    djfs: '가격 설정 방식',
    ggid: '광고 ID',
    time: '시간',
    type: '유형',
    ptgg: '일반 광고',
    gdjg: '고정 가격',
    fdjg: '변동 가격',
    yjfw: '프리미엄 범위',
    unitPrice: '단가',
    totalPrice: '총액',
    sysl: '잔여 수량',
    ywcsl: '완료된 수량',
    cz: '조작',
    xj: '하향',
    sj: '상향',
    edit: '편집',
    delete: '삭제',
    all: '전부',
    qdxjm: '이 광고를 하향하시겠습니까?',
    qdxj: '하향 확인',
    qdsjm: '이 광고를 상향하시겠습니까?',
    qdsj: '상향 확인',
    confirm: '확인',
    cancel: '취소',
    qdscm: '이 광고를 삭제하시겠습니까?',
    deleteAdvertise: '광고 삭제',
  
    tjgm: '구매 통계',
    tjcs: '판매 통계',
    coins: '화폐',
    day7: '7일',
    day15: '15일',
    day30: '30일',
    tj: '통계',
    mrsl: '매수량',
    mcsl: '매도량',
    mrjj: '매수 평균가',
    mcjj: '매도 평균가',
    zcje: '지출액',
    srje: '수입액',
    zsxf: '총 수수료',
    cjdd: '거래 주문',
    zdxx: '거래 정보',
    tips: '팁: 각 거래 쌍마다, 구매 및 판매 통계는 하루에 최대 100회씩만 내보낼 수 있습니다.',
    dcdd: '주문 내보내기',
    orderNo: '주문 번호',
    jybz: '거래 화폐',
    number: '수량',
    total: '총액',
    fee: '수수료',
    zd: '정산',
  
    tjskfs: '결제 방법 추가',
    skfs: '결제 방법',
    name: '이름',
    payAccount: '계정',
    sk: '결제',
    cz: '조작',
    delete: '삭제',
    edit: '수정',
    qdsc: '삭제 확인?',
    tip: '팁',
    deleted: '삭제 취소됨',
    xzskfstt: '결제 방법 추가',
    xgskfstt: '결제 방법 수정',
    khmc: '계좌명',
    yhkh: '은행 계좌 번호',
    khh: '은행명',
    khhszd: '은행 소재지',
    khhmc: '은행명',
    wxzh: '위챗 계정',
    zfbzf: '알리페이 결제',
    ewmsc: 'QR 코드 업로드',
    jymm: '거래 비밀번호',
    srkhh: '은행명을 입력하세요',
    xzszd: '은행 소재지를 선택하세요',
    srkhmc: '은행명을 입력하세요',
    srzh: '계정을 입력하세요',
    scskm: '결제 코드를 업로드하세요',
    srjymm: '거래 비밀번호를 입력하세요',
    scwjgd: '사진 크기는 2MB를 초과할 수 없습니다!',
  
    jnbzj1: '{gradeName}으로서, 보증금 {margin} USDT를 납부했습니다. 현재 남은 광고 한도는 {amount} USDT입니다.',
    k: '가능',
    add: '추가',
    or: '또는',
    reduce: '줄이다',
    margin: '보증금',
    sqsxf: '*플랫폼은 광고 거래 금액의 {fee}%를 수수료로 상인에게 받습니다.',
    hqed: '즉시 인증 상인으로 등록하여 더 높은 한도를 받으십시오.',
    want: '나는 원해요',
    bb: '코인-코인',
    price: '가격',
    ckj: '*시장 참고 가격은 {price} {fiatCurrency}/USDT입니다. 고정 가격은 시장 변동에 따라 변하지 않습니다.',
    jyjg: '거래 가격',
    mdjg: '고정 가격',
    gxhl: '*다양한 은행 및 여러 거래소의 실시간 환율을 종합하여 5분마다 업데이트됩니다.',
    szyj: '프리미엄 설정',
    zjjy: '*음수를 입력할 수 있으며, 설정된 프리미엄에 따라 고정된 가격에서 할인 거래를 할 수 있습니다.',
    yjsz: '*거래 가격=고정 가격*（1+프리미엄 설정）',
    jyxz: '거래 제한',
    jysl: '거래량',
    sygged: '*거래량은 현재 남은 광고 한도를 초과할 수 없습니다.',
    zxxe: '최소 거래 한도',
    zdxe: '최대 거래 한도',
    fkqx: '결제 기한',
    xnfk: '*이 기간 내에 결제해야 합니다.',
    fkfs: '결제 방법',
    xzskfs: '*모든 코인의 결제 방법은 최대 5종류까지 추가할 수 있습니다.',
    yhjy: '고급 실명 인증을 완료하지 않은 사용자와는 거래할 수 없습니다.',
    jygg: '*초급 실명 인증만 완료한 사용자는 거래 광고에 접근할 수 없습니다.',
    cyjy: '지정된 구매 횟수를 완료하지 않은 사용자를 선택하세요. 거래에 참여할 수 없습니다.',
    bmfx: '*구매를 완료한 사용자는 자금 출처의 불확실성을 크게 줄입니다.',
    qxz: '선택하세요',
    jybz: '거래 메모',
    tyzs: '거래 규칙을 인지하고 준수하기로 합니다.',
    jygz: '《거래 규칙》',
    yzm: '인증 코드',
    save: '저장',
    fbgg: '광고 게시',
    jsbzjcg: '보증금 감소 완료',
    zjbzjcg: '보증금 추가 완료',
    xzfs: '결제 방법 또는 결제 방법을 선택하세요.',
    bankTip1: '은행 카드는 세 가지 결제 방법을 초과할 수 없습니다.',
    wxTip2: '위챗은 세 가지 결제 방법을 초과할 수 없습니다.',
    zfbTip3: '알리페이는 세 가지 결제 방법을 초과할 수 없습니다.',
    syjg: '가격을 입력하세요',
    syjysl: '거래량을 입력하세요',
    zxxe: '최소 거래 한도를 입력하세요',
    zdxe: '최대 거래 한도를 입력하세요',
    fkqx: '결제 기한을 입력하세요',
    tyjygz: '거래 규칙에 동의하세요',
    tpyzm: '그림 인증 코드를 입력하세요',
    jydx: '거래 상대',

    zjbzj: '보증금 추가',
    jsbzj: '보증금 감소',
    xzdgged: '현재 최대 광고 한도',
    zjbzjse: '보증금 추가 금액',
    jsbzjse: '보증금 감소 금액',
    zjhbzjed: '보증금 추가 후 잔액',
    jshbzjed: '보증금 감소 후 잔액',
    balance: '잔액',
    sy: '남은',
    kzj: '추가 가능',
    kjs: '감소 가능',
    otcsjxy: 'OTC 상인 서비스 규칙 협정',
    xsgz: '초보자 안내',
    jygz: '거래 규칙',
    jnbzj: 'OTC의 합법성과 규범적인 행동을 보장하기 위해, 상인은 일정한 보증금을 지불하도록 요구됩니다.',
    zjjnbzj: '보증금은 기본 금액과 추가 금액 두 부분으로 구성되어 있습니다. 기본 금액은 필수 부분이며, 추가 부분은 선택 사항입니다.',
    kxs: '기본 금액을 지불하면',
    fbgged: '（CNYT를 기준으로 환산됨）의 광고 한도를 받을 수 있습니다;',
    ggedbl: '추가 보증금은 광고 한도 대비 비율로 계산됩니다.',
    eg: '추가 100 USDT의 경우 광고 한도가 기본 한도에 100 x',
    ggzedjs: '광고 총 한도는 기본 광고 한도 + 추가 광고 한도 x의 공식에 따라 계산됩니다.',
    ttsjzxed: '일반 상인의 추가 보증금 최소 금액은',
    zdedw: '최대 금액은',
    mgsjzd: '각 상인은 최대 3개의 구매 광고 및 3개의 판매 광고를 게시할 수 있습니다.',
    hljj: 'USDT 대 CNYT의 환율은 BiKing 플랫폼 관련 거래 쌍의 지난 24시간 평균가를 취합니다 (1시간마다 기록하며, 최고가와 최저가를 제외한 후에). 환율이 변동할 때, 기존 광고 한도는 변하지 않습니다.',
    jcbzj: '기본 보증금',
    xt: '선택 사항',
    njhded: '받게 되는 광고 한도는:',
    mbye: '코인 잔고:',
    zhzcbz: '계정 자산이 부족합니다. 자산 계정에서 이체할 수 있습니다.',
    qhz: '이체하러 가기',
    qdjnbzj: '기본 보증금을 지불하시겠습니까?',
    tjbzj: '보증금 추가',
    sqsjcg: '상인 신청 성공',
    exchange:'환율 전환'
  }
  export {
      advertise
  }


// WEBPACK FOOTER //
// ./src/i18n/lang/advertise/kr.js